import { render, staticRenderFns } from "./clienteleInfo.vue?vue&type=template&id=6d56c164&scoped=true&"
import script from "./clienteleInfo.vue?vue&type=script&lang=js&"
export * from "./clienteleInfo.vue?vue&type=script&lang=js&"
import style0 from "./clienteleInfo.vue?vue&type=style&index=0&id=6d56c164&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d56c164",
  null
  
)

export default component.exports